<div class="container-fluid bg-radial my-0 pt-5 vh-100">
  <div class="container h-100 my-0 pt-5 text-center">
    <contact-us-result [isLoggedIn]="false"></contact-us-result>
  </div>
</div>
